import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=5513485f&scoped=true&"
import script from "./StatusTag.vue?vue&type=script&lang=ts&"
export * from "./StatusTag.vue?vue&type=script&lang=ts&"
import style0 from "./StatusTag.vue?vue&type=style&index=0&id=5513485f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5513485f",
  null
  
)

export default component.exports